import { DIGITAL_PRODUCTS_FEE_PERCENTAGE } from '@fourthwall/utils/dist/constants'
import React from 'react'
import { CostItem, EstimatedFees, EstimatedProfit } from '../components/CostItem'

export type Props = {
  includeFeesValue: boolean
  cost: number
  unitProfit: number
  feesValue: number
  digitalFeePercentage?: number
}

export const DigitalPricing = ({
  includeFeesValue,
  digitalFeePercentage = DIGITAL_PRODUCTS_FEE_PERCENTAGE,
  cost,
  unitProfit,
  feesValue,
}: Props) => {
  return (
    <div>
      <CostItem
        name={`Hosting and server costs (${digitalFeePercentage}%)`}
        value={cost}
        negative
      />
      {includeFeesValue && <EstimatedFees value={feesValue} />}
      <EstimatedProfit value={unitProfit} />
    </div>
  )
}
